import Image from "next/image";

export default function TestimonialsSection({
  testimonial,
  author,
  company,
  avatar,
}: {
  testimonial: React.ReactNode;
  author: string;
  company: string;
  avatar: string;
}) {
  return (
    <section className="">
      <div className="mx-auto max-w-6xl md:px-6 px-12">
        <div className="mx-auto max-w-4xl">
          <blockquote>
            <div className="text-lg font-semibold sm:text-xl md:text-2xl">{testimonial}</div>

            <div className="mt-8 flex items-center gap-6">
              <Image className="h-14 w-14 object-cover rounded-full" src={avatar} alt={author} height={48} width={48} />
              <div className="space-y-1 border-l pl-6">
                <cite className="font-medium">{author}</cite>
                <span className="text-muted-foreground block text-sm">{company}</span>
              </div>
            </div>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
